import LEAdminSchoolData from './LEAdminSchoolData';

export default LEAdminSchoolData;
